import Vue from "vue";
import Component from "vue-class-component";
import { MUTATION_TYPES } from "@/store/const";

@Component
export default class WithDoNotDisturb extends Vue {
  public get doNotDisturb(): boolean {
    return this.$store.state.doNotDisturb;
  }

  public doNotDisturbSet(state: boolean) {
    this.$store.commit(MUTATION_TYPES.SET_DO_NOT_DISTURB, state);
    return this.doNotDisturb;
  }
}
